/**
 * Padrão visual dos footers do QuotationCalculator (passo 1 e passo 2).
 *
 * - confirm: ação de confirmação/fechamento (verde fixo)
 * - outline: ações secundárias (copiar, estacionar, novo)
 * - auxiliary: ações intermediárias (PIX, etc.)
 */

export const quotationFooter = {
	shell: (compact?: boolean) =>
		`border-t border-navy-700 ${compact ? "p-2" : "p-2.5 sm:p-3"} bg-navy-900/70 backdrop-blur-sm flex-shrink-0 space-y-2`,
	row2: "grid grid-cols-2 gap-2",
	/** Botão de confirmação — sempre verde, inclusive quando disabled */
	confirm:
		"h-10 w-full rounded-lg text-sm font-semibold disabled:!bg-green-600 disabled:hover:!bg-green-600 disabled:!opacity-40",
	/** Botão secundário — outline navy */
	outline:
		"h-10 w-full rounded-lg text-sm font-medium bg-navy-800/70 hover:bg-navy-700 text-gray-100 border border-navy-500/50 disabled:opacity-40",
	/** Ação auxiliar de fluxo (ex.: PIX) — azul primário do sistema */
	auxiliary:
		"h-10 w-full rounded-lg text-sm font-medium disabled:!bg-blue-600 disabled:hover:!bg-blue-600 disabled:!opacity-40",
	hint: "text-center text-[11px] text-gray-500 leading-snug",
} as const;
